import api from "../../../../lib/api";
import { IWarehouseCreate, IWarehouseListSearch, IEditWarehousePayload } from "../../../../types/master/warehouseInterface";

export const createWarehouseApi = async (data: IWarehouseCreate) => {
  return await api.post(`/warehouse`, data);
};

export const getWarehouseListApi = async (data: IWarehouseListSearch) => {
  return await api.get(`/warehouse/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getWarehouseDataByIdApi = async (id: string) => {
  return await api.get(`/warehouse/${id}`)
}

export const editWarehouseDataByIdApi = async (payload: IEditWarehousePayload) => {
  return await api.put(`/warehouse/${payload.id}`, payload.data);
};

export const deleteWarehouseApi = async (id: number) => {
  return await api.delete(`/warehouse/${id}`);
};